import { Pencil, Trash2, Users } from "lucide-react";

/** Single client tile in the AdminClients grid. */
export default function ClientCard({ client, caregivers, onEdit, onDelete }) {
  const cgNames = caregivers
    .filter((u) => client.assigned_caregiver_ids?.includes(u.id))
    .map((u) => u.name);

  return (
    <div className="card-surface p-4" data-testid={`client-card-${client.id}`}>
      <div className="flex items-start justify-between">
        <div>
          <h3 className="font-heading text-base font-medium">{client.name}</h3>
          {client.address && (
            <div className="text-xs text-clinical-subtext mt-0.5">{client.address}</div>
          )}
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={() => onEdit(client)}
            className="btn-ghost p-1.5"
            data-testid={`edit-${client.id}`}
          >
            <Pencil className="h-4 w-4" />
          </button>
          <button
            onClick={() => onDelete(client)}
            className="btn-ghost p-1.5 hover:!text-destructive"
            data-testid={`delete-${client.id}`}
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      </div>
      {client.notes && (
        <p className="mt-3 text-sm text-clinical-subtext line-clamp-3">{client.notes}</p>
      )}
      <div className="mt-3 flex flex-wrap gap-1.5">
        {client.scheduled_days?.map((d) => (
          <span key={d} className="pill bg-clinical-bg text-clinical-subtext">{d}</span>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-1.5 text-xs text-clinical-subtext">
        <Users className="h-3 w-3" />
        {cgNames.length ? cgNames.join(", ") : "Unassigned"}
      </div>
    </div>
  );
}
